import ReactOnRails from "react-on-rails";
import MatchingGifts from "shared/components/MatchingGifts";

ReactOnRails.register({ MatchingGifts });
